// Time range constants
export const DEFAULT_MONTH_RANGE = 6;

// Date formatting constants
export const TRIM_CURRENT_DATE = 16;

// Modal store timeouts
export const STORER_OPEN_TIMEOUT = 500;
export const STORER_HIGHLIGHT_TIMEOUT = 500;

// Index constants
export const FIRST_INDEX = 0;

// Store pagination constants
export const STORE_LIMIT = 100;

// Pinning configuration
export const PINNING_INITIAL_STATE = ["pin"];

// Legend tags
export const LEGEND_TAGS = {
  COMPLETED_WARNING: "COMPLETED_WARNING",
  PARTIALLY_REVOKED: "PARTIALLY_REVOKED",
  REVOKED: "REVOKED",
  ACTIVE: "ACTIVE",
  DISABLED: "DISABLED",
};

// Column accessor keys
export const COLUMN_KEYS = {
  STATUS: "DataAcquisitionInstanceStatusName",
  DATA_ACQUISITION_NAME: "DataAcquisitionName",
  TRIGGER_TYPE: "triggerType",
  START_DATE: "StartDate",
  END_DATE: "EndDate",
  TOTAL_RAW_RECORDS: "TotalRawRecords",
  TOTAL_RECORDS_FOR_MATCHING: "TotalRecordsForMatching",
  RECORDS_RANGE: "RecordsRange",
};

// Trigger type constants
export const TRIGGER_TYPES = {
  FILE_DROP: "FileDrop",
  SCHEDULE: "Schedule",
  MANUAL: "Manual",
};

// Filter keys
export const FILTER_KEYS = {
  TRIGGER_TYPE: "triggerType",
  STATUS_TAG: "DataAcquisitionInstanceStatusTag",
  ACQUISITION_TAG: "DataAcquisitionTag",
  DATA_ACQUISITION_NAME: "DataAcquisitionName",
  ACQUISITION: "Acquisition",
};

// Action type tags
export const ACTION_TYPES = {
  VIEW_DETAILS: "VIEW_DETAILS",
  REVOKE: "REVOKE",
  DOWNLOAD_RAW_DATA: "DOWNLOAD_RAW_DATA",
  DOWNLOAD_FAULTY_RECORDS: "DOWNLOAD_FAULTY_RECORDS",
  DOWNLOAD_REVOKED_RECORDS: "DOWNLOAD_REVOKED_DATA",
};

